import gql from "graphql-tag";

export const ADD_COACH_TO_CHILD = gql`
  mutation AddCoachesToChild(
    $coachUuid: ID!
    $clientUuid: ID!
    $additionalCoachingSessions: Int
  ) {
    addCoachesToChild(
      coachUuid: $coachUuid
      clientUuid: $clientUuid
      additionalCoachingSessions: $additionalCoachingSessions
    ) {
      returnMessage {
        status
        message
      }
      child {
        id
        name
      }
    }
  }
`;
